export const REBORROW_FLAG = {
  0: 'Not Reborrow',
  1: 'Reborrow',
}
export const REBORROW_FLAG_EN = {
  0: 'Not Reborrow',
  1: 'Reborrow',
}

export const SEX = {
  0: 'unknown',
  1: 'man',
  2: 'woman',
}

export const CONTACT_TYPE = {
  0: 'firstContact',
  1: 'secondContact',
  2: 'thirdContact',
}

export const TRADESTATUS = {
  '00': 'In Transaction',
  '01': 'Transaction Success',
  '02': 'Transaction Refund',
  '03': 'Transaction Cancelled',
  '04': 'Transaction Failed',
  '05': 'Transaction Queued',
}

export const TRADETYPE = {
  0: 'Withdrawal',
  1: 'Deposit',
}

export const ORDER_TYPE = {
  0: 'Orden normal',
  1: 'Orden de prórroga',
}

export const ORDER_TYPE_CN = {
  0: 'Normal Order',
  1: 'Extension Order',
}

export const ORDER_TYPE_EN = {
  0: 'normal order',
  1: 'Extension order',
}

export const STATUS_TYPE = {
  0: 'No',
  1: 'Yes',
}
export const REFUND_TRADE_STATUS = {
  '00': 'In Transaction',
  '01': 'Transaction Success',
  '02': 'Transaction Refund',
  '03': 'Transaction Cancelled',
  '04': 'Transaction Submitted',
  '05': 'Transaction Failed',
}

export const CURP_TYPE = {
  0: 'CC',
  1: 'CE',
  2: 'TI',
  3: 'NIT',
  4: 'Pasaporte',
}

export const COLLECT_TYPE = {
  1: 'BANK',
  2: 'NEQUI',
}

export const PAYOUT_STATUS = {
  '00': 'Gửi khoản vay',
  '01': 'Thực hiện giải ngân thành công',
  '02': 'Thực hiện giải ngân thất bại',
}

export const REPAY_STATUS = {
  '00': 'Khởi tạo thanh toán',
  '01': 'Thanh toán thành công',
  '02': 'Thanh toán thất bại',
  '03': 'Chưa thanh toán',
}

export const PAYTYPE = {
  '00': 'Trả nợ đúng hạn',
  '01': 'Thanh toán gia hạn',
  '02': 'Trả nợ một phần',
  '03': 'Trả góp',
  '0304': 'Thanh toán trả góp gia hạn',
  '0101': 'Trả một phần',
  '0301': 'Trả góp một phần',
}


